import type { RemoteConfig } from '../../constants/remote-config';

export const remoteConfigSelector = (state: any) => state.remoteConfig as RemoteConfig;
